// export default function HeroSection() {
//   return (
//     <section className="relative overflow-hidden">
//       {/* Background video */}
//       <video
//         src="/hero1.mp4"
//         autoPlay
//         loop
//         muted
//         playsInline
//         className="absolute inset-0 h-full w-full object-cover"
//       ></video>

//       {/* dark overlay */}
//       <div className="absolute inset-0 bg-[#0a1220]/60"></div>

//       {/* centered content */}
//       <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-28 text-center flex flex-col items-center justify-center">
//         <p className="uppercase tracking-widest text-[#66e7f9] font-semibold text-5xl sm:text-7xl md:text-8xl">Main Street</p>
//         <h1 className="text-4xl md:text-7xl text-white font-extrabold leading-tight">CAR WASH</h1>
//         <p className="mt-4 text-white/80 max-w-xl">Red Bluff's premier eco-friendly car wash</p>
//         <div className="mt-8 flex flex-wrap justify-center gap-3">
//           <a
//             href="#services"
//             className="px-6 py-3 rounded-lg bg-cyan-400 text-[#0a1220] font-semibold"
//           >
//             See Services
//           </a>
//           <a
//             href="#pricing"
//             className="px-6 py-3 rounded-lg border border-white/30 text-white"
//           >
//             View Pricing
//           </a>
//         </div>
//       </div>

   
//     </section>
//   );
// }
// 

import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative overflow-hidden">
      {/* Background video */}
      <video
        src="/hero.mp4"
        autoPlay
        loop
        muted
        playsInline
        className="absolute inset-0 h-full w-full object-cover"
      />

      {/* overlay */}
      <div className="absolute inset-0 bg-[#0a1220]/65" />

      {/* centered content */}
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-24 flex items-center justify-center">
        <div className="text-center">

          {/* Main Street → slightly bigger */}
          <p className="uppercase tracking-wide text-[#66e7f9] font-semibold
                         text-4xl sm:text-5xl md:text-6xl">
            Main Street
          </p>

          {/* Car Wash → slightly smaller */}
          <h1 className="mt-1 text-3xl sm:text-4xl md:text-5xl 
                         text-white font-extrabold leading-tight">
            CAR WASH
          </h1>

          <p className="mt-4 text-white/80 max-w-xl mx-auto text-base">
            Red Bluff's premier eco-friendly, solar-powered car wash.
          </p>

          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <Link
              to="/services"
              className="px-6 py-3 rounded-lg bg-cyan-400 text-[#0a1220] font-semibold"
            >
              See Services
            </Link>
            <Link
              to="/pricing"
              className="px-6 py-3 rounded-lg border border-white/40 text-white hover:bg-white/10"
            >
              View Pricing
            </Link>
          </div>

        </div>
      </div>
    </section>
  );
}

